<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false">
        <el-form ref="formValidate" :model="model" label-width="120px">
            <el-form-item label="厂商名称：" prop="name">
                <span>{{model.name}}</span>
            </el-form-item>
            <el-form-item label="厂家介绍：" prop="description">
                <span>{{model.description}}</span>
            </el-form-item>
            <el-form-item label="排序：" prop="order_index">
                <span>{{model.order_index}}</span>
            </el-form-item>
            <el-form-item label="添加人名称：" prop="creator_name">
                <span>{{model.creator_name}}</span>
            </el-form-item>
            <el-form-item label="添加时间：" prop="create_time">
                <span>{{model.create_time}}</span>
            </el-form-item>
            <el-form-item label="更新人名称：" prop="update_name">
                <span>{{model.update_name}}</span>
            </el-form-item>
            <el-form-item label="更新时间：" prop="update_time">
                <span>{{model.update_time}}</span>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="closeDialog" size="medium">关 闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: 'producerInfo',
    mixins: [editutil],
    data() {
        return {
            model: {
                name: '',
                description: '',
                order_index: '',
                creator_id: '',
                creator_name: '',
                create_time: '',
                update_id: '',
                update_name: '',
                update_time: '',
            },
            getObj:{
                url:'/api/admin/producer/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: [],
        };
    },
    methods: {}
};
</script>